"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var related_1 = tslib_1.__importDefault(require("rest-resource/dist/related"));
var SigmaRelatedManager = /** @class */ (function (_super) {
    tslib_1.__extends(SigmaRelatedManager, _super);
    function SigmaRelatedManager(to, value) {
        var _this = _super.call(this, to, value) || this;
        _this.batchSize = Infinity;
        return _this;
    }
    SigmaRelatedManager.prototype.toString = function () {
        return this.primaryKeys.join(', ');
    };
    return SigmaRelatedManager;
}(related_1.default));
exports.SigmaRelatedManager = SigmaRelatedManager;
//# sourceMappingURL=related.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/related.js
// module id = ko3t
// module chunks = 0